import { createFileRoute } from "@tanstack/react-router";

import { CoachedLive } from "@/features/training/modules/coached-live/coached-live";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/training/coached/$trainingId")({
  loader: () => ({ crumb: m.coached_live_title() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { trainingId } = Route.useParams();
  return <CoachedLive trainingId={trainingId} />;
}
